import React from 'react'
import PropTypes from 'prop-types'
import NumberFormat from 'react-number-format'
import { Container, Columns, Column } from '@resurs/midas-react'
import { midas, variables } from '@resurs/midas'
import { LocaleState } from '@merchant-portal/merchant-portal-base'
import { getText } from '../../../internal/TextLabels'

import Page from '../../../internal/Page'
import { CustomerHelper } from '../../../util/customerHelper'

import govIdFormat from '../../../util/govIdFormat'
import { getPaymentMethodDescription } from '../../../util/payApplyUtils'

class PayApplyApplicationInfoUI extends React.Component {
  constructor(props) {
    super(props)

    this.state = { infoOpen: false }
  }

  render() {
    const { data } = this.props
    const customerHelper = CustomerHelper.fromPayApply(data)
    const address = customerHelper.address
    const itemStyle = {
      display: 'flex',
      flexDirection: 'column',
      flex: '1 1 100%',
    }

    const paymentMethod =
      data.current.selectedPaymentMethod ||
      data.current.selectedPendingPaymentMethod
    const limit =
      (data.formSpec.formSchema && data.current.selectedLimit) ||
      (data.current.selectedPendingPaymentMethod &&
        data.current.selectedPendingPaymentMethod.approvedAmount)

    return (
      <Container grid960>
        <Columns>
          <Column col1 colMd0 />
          <Column col10 colMd12>
            <Page title={getText('payApply.summary.currentApplication')}>
              <div
                style={{
                  maxHeight: this.state.infoOpen ? '100%' : '11rem',
                  overflow: 'hidden',
                  padding: '2rem',
                  display: 'flex',
                  flexDirection: 'column',
                  position: 'relative',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                  }}
                >
                  <div
                    id="applicant-info-box"
                    style={{ ...itemStyle, paddingRight: '2rem' }}
                  >
                    <label
                      style={{ fontSize: 'small' }}
                      className={midas.formLabel}
                    >
                      {getText('payApply.summary.applicant')}
                    </label>
                    {address && <div>{address.fullName}</div>}
                    <div>
                      {govIdFormat(
                        customerHelper.governmentId,
                        this.context.country,
                      )}
                    </div>
                    {address && (
                      <>
                        <div>
                          <div style={{ paddingTop: '2rem' }}>
                            {address.addressRow1}
                          </div>
                          <div>
                            {address.postalCode} {address.postalArea}
                          </div>
                        </div>

                        {customerHelper.email && (
                          <div className={midas.mt5}>
                            {customerHelper.email}
                          </div>
                        )}
                        {customerHelper.mobilePhoneNumber && (
                          <div>{customerHelper.mobilePhoneNumber}</div>
                        )}
                      </>
                    )}
                  </div>
                  <div
                    id="product-info-box"
                    style={{ ...itemStyle, padding: '0rem 2rem' }}
                  >
                    <label
                      style={{ fontSize: 'small' }}
                      className={midas.formLabel}
                    >
                      {getText('payApply.summary.paymentMethod')}
                    </label>
                    {paymentMethod ? (
                      <div style={{ wordBreak: 'break-word' }}>
                        {getPaymentMethodDescription(paymentMethod)}
                      </div>
                    ) : (
                      <div>{getText('payApply.summary.notSelected')}</div>
                    )}
                  </div>
                  <div
                    id="credit-limit-info-box"
                    style={{ ...itemStyle, padding: '0rem 2rem' }}
                  >
                    <label
                      style={{ fontSize: 'small' }}
                      className={midas.formLabel}
                    >
                      {getText('payApply.summary.totalLimit')}
                    </label>
                    {limit ? (
                      <div>
                        <NumberFormat
                          value={limit}
                          displayType="text"
                          thousandSeparator=" "
                          renderText={val => getText('default.currency', val)}
                        />
                      </div>
                    ) : (
                      <span>-</span>
                    )}
                  </div>
                  <div
                    id="status-info-box"
                    style={{ ...itemStyle, paddingLeft: '2rem' }}
                  >
                    <label
                      style={{ fontSize: 'small' }}
                      className={midas.formLabel}
                    >
                      {getText('payApply.summary.applicationStatus')}
                    </label>
                    {data.current.status && (
                      <div>
                        {getText(
                          `payApply.paymentStatus.${data.current.status}`,
                        )}
                      </div>
                    )}
                    {!data.current.status && (
                      <div>{getText('payApply.paymentStatus.notStarted')}</div>
                    )}
                  </div>
                </div>
                <div
                  style={{
                    position: 'absolute',
                    right: 0,
                    left: 0,
                    bottom: 0,
                    height: '2rem',
                    background:
                      'linear-gradient(rgba(255,255,255,0), rgba(255,255,255,0.8))',
                  }}
                />
              </div>
            </Page>
            {!customerHelper.isAnonymous && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  marginTop: '-1.1rem',
                  marginRight: '1rem',
                }}
              >
                <div
                  className={midas.hand}
                  style={{
                    borderLeft: `1px solid ${variables.coreBorderColor}`,
                    borderRight: `1px solid ${variables.coreBorderColor}`,
                    borderBottom: `1px solid ${variables.coreBorderColor}`,
                    borderTop: '1px solid white',
                    padding: '0.5rem',
                    fontSize: '1.1rem',
                    background: 'white',
                  }}
                  role="menu"
                  tabIndex={0}
                  onClick={() =>
                    this.setState(state => ({ infoOpen: !state.infoOpen }))
                  }
                  onKeyPress={() =>
                    this.setState(state => ({ infoOpen: !state.infoOpen }))
                  }
                >
                  <span>
                    {this.state.infoOpen
                      ? getText('payApply.summary.less')
                      : getText('payApply.summary.more')}
                  </span>
                  <i
                    style={{
                      transform: this.state.infoOpen
                        ? 'rotate(180deg)'
                        : 'rotate(0deg)',
                    }}
                    className={[midas.icon, midas.iconCaret].join(' ')}
                  />
                </div>
              </div>
            )}
          </Column>
        </Columns>
      </Container>
    )
  }
}

PayApplyApplicationInfoUI.propTypes = {
  data: PropTypes.object.isRequired,
}

PayApplyApplicationInfoUI.contextType = LocaleState

export default PayApplyApplicationInfoUI
